import { React, useState } from 'react';
import '../../App.css';
import { Grid, Box, Button, Paper, FormControl, InputLabel, Select, MenuItem, FormHelperText, Typography, Stack } from '@mui/material';
import { Timelapse } from '@mui/icons-material';
import * as monthList from '../../services/monthList';
import * as yearList from '../../services/yearList';
import Popup from '../Popup';
import DataTable from '../DataTable';

// Custom component for required field label
const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
  </span>
);

const monthOptions = monthList.getMonthList();
const yearOptions = yearList.getYearList();

const initialFValues = {
  id: 0,
  toMonth: '',
  toYear: '',
  fromMonth: '',
  fromYear: '',
};

function CombineSalaryReportDuration() {
  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [openPopup, setOpenPopup] = useState(false);

  const validate = () => {
    let temp = {};
    temp.fromMonth = values.fromMonth.length !== 0 ? '' : 'This field is required.';
    temp.fromYear = values.fromYear.length !== 0 ? '' : 'This field is required.';
    temp.toMonth = values.toMonth.length !== 0 ? '' : 'This field is required.';
    temp.toYear = values.toYear.length !== 0 ? '' : 'This field is required.';

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === '');
  };

  function handleInputChange(e) {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: '',
      });
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      alert('Submitted!');
      // You can add your data fetching logic here
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', margin: '10px', padding: '50px', fontWeight: '500px' }}>
      <Paper elevation={5} sx={{ width: '1000px' }}>
        <Grid className="form-title" container spacing={2} style={{marginTop: "10px"}} justifyContent="center" alignItems="center">
          <Grid item>
            <Timelapse sx={{ width: 45, height: 45 }} />
          </Grid>
          <Grid item>
            <Typography variant="h5">Combine Salary Report Duration</Typography>
          </Grid>
        </Grid>

        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>
          <Box sx={{ margin: '30px' }}>
            {/* Main container for From and To sections, in a single row */}
            <Grid container spacing={4} justifyContent="center">
              {/* From Section */}
              <Grid item>
                <Stack spacing={1}>
                  <Typography variant="body2" fontWeight="bold" textAlign="center">
                    From
                  </Typography>
                  {/* Month and Year in a single horizontal line */}
                  <Stack direction="row" spacing={2} alignItems="center">
                    <FormControl variant="outlined" sx={{ width: '120px' }} {...(errors.fromMonth && { error: true })}>
                      <InputLabel>
                        <RequiredLabel label="Month" />
                      </InputLabel>
                      <Select label="Month" name="fromMonth" size="small" value={values.fromMonth} onChange={handleInputChange}>
                        <MenuItem value="">None</MenuItem>
                        {monthOptions.map((item) => (
                          <MenuItem key={item.id} value={item.title}>
                            {item.title}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.fromMonth && <FormHelperText>{errors.fromMonth}</FormHelperText>}
                    </FormControl>

                    <FormControl variant="outlined" sx={{ width: '120px' }} {...(errors.fromYear && { error: true })}>
                      <InputLabel>
                        <RequiredLabel label="Year" />
                      </InputLabel>
                      <Select label="Year" name="fromYear" size="small" value={values.fromYear} onChange={handleInputChange}>
                        <MenuItem value="">None</MenuItem>
                        {yearOptions.map((item) => (
                          <MenuItem key={item.id} value={item.title}>
                            {item.title}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.fromYear && <FormHelperText>{errors.fromYear}</FormHelperText>}
                    </FormControl>
                  </Stack>
                </Stack>
              </Grid>

              {/* To Section */}
              <Grid item>
                <Stack spacing={1}>
                  <Typography variant="body2" fontWeight="bold" textAlign="center">
                    To
                  </Typography>
                  {/* Month and Year in a single horizontal line */}
                  <Stack direction="row" spacing={2} alignItems="center">
                    <FormControl variant="outlined" sx={{ width: '120px' }} {...(errors.toMonth && { error: true })}>
                      <InputLabel>
                        <RequiredLabel label="Month" />
                      </InputLabel>
                      <Select label="Month" name="toMonth" size="small" value={values.toMonth} onChange={handleInputChange}>
                        <MenuItem value="">None</MenuItem>
                        {monthOptions.map((item) => (
                          <MenuItem key={item.id} value={item.title}>
                            {item.title}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.toMonth && <FormHelperText>{errors.toMonth}</FormHelperText>}
                    </FormControl>

                    <FormControl variant="outlined" sx={{ width: '120px' }} {...(errors.toYear && { error: true })}>
                      <InputLabel>
                        <RequiredLabel label="Year" />
                      </InputLabel>
                      <Select label="Year" name="toYear" size="small" value={values.toYear} onChange={handleInputChange}>
                        <MenuItem value="">None</MenuItem>
                        {yearOptions.map((item) => (
                          <MenuItem key={item.id} value={item.title}>
                            {item.title}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.toYear && <FormHelperText>{errors.toYear}</FormHelperText>}
                    </FormControl>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>

            {/* Buttons Section - Centered below the form inputs */}
            <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '40px', gap: '10px', flexWrap: 'wrap' }}>
              <Button className="form-btn" color="success" variant="contained" type="submit" sx={{ height: 40 }}>
                Display
              </Button>
              <Button variant="outlined" color="secondary" sx={{ height: 40 }}>
                Print
              </Button>
              <Button variant="outlined" color="primary" sx={{ height: 40 }}>
                Export to Excel
              </Button>
            </Box>
          </Box>
          <DataTable />
        </form>

        <Popup title="Employee Form" openPopup={openPopup} setOpenPopup={setOpenPopup}>
          <DataTable />
        </Popup>
      </Paper>
    </Box>
  );
}

export default CombineSalaryReportDuration;